import { SUPABASE_URL } from './supabase';

export function getApiUrl(path: string): string {
  // Convert relative /functions/v1/... paths to absolute Supabase URLs
  if (path.startsWith('/functions/') || path.startsWith('/rest/') || path.startsWith('/storage/')) {
    return `${SUPABASE_URL}${path}`;
  }
  return path;
}
